<template>
    <div>
        <div class="columns is-multiline">
            <b-loading :is-full-page="false" :active.sync="loading" :can-cancel="true"></b-loading>
            <div v-for="(c, i) in couponsList" :key="i" class="column is-full">
                <article class="media">
                    <div class="media-content">
                        <div class="columns is-multiline m-t-10">
                            <div class="column is-one-third">
                                    <b-field label="Moneda">
                                        <b-select
                                        @input="updateCoupon(c)"
                                        expanded
                                        v-model="c.currency">
                                            <option value="">-----</option>
                                            <option v-for="x in currencies" :key="x.id" :value="x.id">{{x.title}}</option>
                                        </b-select>
                                    </b-field>
                                </div>
                            <div class="column is-one-third">
                                <b-field label="Activo" >
                                    <b-switch
                                    @input="updateCoupon(c)"
                                    v-model="c.active">
                                    </b-switch>
                                </b-field>
                            </div>
                            <div class="column is-one-third">
                                <b-field label="Exclusivo para usuarios" >
                                    <b-switch
                                    @input="updateCoupon(c)"
                                    v-model="c.onlyUsers">
                                    </b-switch>
                                </b-field>
                            </div>

                            <div class="column is-half">
                                <b-field label="Titulo" label-position="on-border">
                                    <b-input
                                    @input="updateCoupon(c)"
                                    v-model="c.title">
                                    </b-input>
                                </b-field>
                            </div>
                            <div class="column is-half">
                                <b-field label="Codigo" label-position="on-border">
                                    <b-input
                                    maxlength="10"
                                    @input="updateCoupon(c)"
                                    v-model="c.code">
                                    </b-input>
                                </b-field>
                            </div>

                            <div class="column is-one-third">
                                <b-field label="% Descuento" label-position="on-border" message="Descuento porcentual. Dejar en 0 descuento fijo para que este aplique">
                                    <b-numberinput
                                    @input="updateCoupon(c)"
                                    :controls="false"
                                    v-model="c.discountPercent">
                                    </b-numberinput>
                                </b-field>
                            </div>
                            <div class="column is-one-third">
                                <b-field label="$ Descuento" label-position="on-border" message="Descuento fijo. Dejar en 0 descuento porcentual para que este aplique">
                                    <b-numberinput
                                    @input="updateCoupon(c)"
                                    :controls="false"
                                    v-model="c.discountFixed">
                                    </b-numberinput>
                                </b-field>
                            </div>
                            <div class="column is-one-third">
                                <b-field label="Valor minimo para usarlo" label-position="on-border" message="Monto minimo necesario de la orden para que este cupon se pueda usar">
                                    <b-numberinput
                                    @input="updateCoupon(c)"
                                    :controls="false"
                                    v-model="c.minimumAmmount">
                                    </b-numberinput>
                                </b-field>
                            </div>
                        </div>
                    </div>
                    <div class="media-right">
                        <a class="has-text-danger" @click="deleteCoupon(c.id)">
                            <b-icon icon="trash" size="is-small"></b-icon>
                            Delete
                        </a>
                    </div>
                </article>
                <hr>
            </div>
            
            <div v-if="!couponsList" class="column is-full ">
                <h2 class="title has-text-centered">Todavia no creaste cupones!</h2>
                <p class="has-text-centered">Dales a tu clientes un motivo para finalizar su compra y/ para registrarse!.</p>
            </div>

            <div class="column is-full has-text-centered">
                <b-button @click="addModalActive=true" type="is-primary" rounded>
                    Agregar cupon
                    <b-icon icon="plus" size="is-small" class="m-l-5"></b-icon>
                </b-button>
            </div>
        
        </div>

        <b-modal :active.sync="addModalActive" scroll="keep">
            <div class="modal-card" style="width:auto;">
                <div class="modal-card-body">
                    <article v-for="(c, i) in newCoupons" :key="i" class="media">
                        <div class="media-content">
                            <div class="columns is-multiline m-t-10">
                                <div class="column is-full">
                                    <b-field>
                                    <a class="has-text-danger" @click="removeNewCoupon(i)">
                                        <b-icon icon="trash" class="m-r-5"></b-icon>
                                        Eliminar
                                    </a>
                                </b-field>
                                </div>
                                <div class="column is-one-third">
                                    <b-field label="Moneda">
                                        <b-select
                                        expanded
                                        v-model="c.currency">
                                            <option value="">-----</option>
                                            <option v-for="x in currencies" :key="x.id" :value="x.id">{{x.title}}</option>
                                        </b-select>
                                    </b-field>
                                </div>
                                <div class="column is-one-third">
                                    <b-field label="Activo">
                                        <b-switch
                                        v-model="c.active">
                                        </b-switch>
                                    </b-field>
                                </div>
                                <div class="column is-one-third">
                                    <b-field label="Exclusivo para usuarios">
                                        <b-switch
                                        v-model="c.onlyUsers">
                                        </b-switch>
                                    </b-field>
                                </div>

                                <div class="column is-half">
                                    <b-field label="Titulo" label-position="on-border">
                                        <b-input
                                        v-model="c.title">
                                        </b-input>
                                    </b-field>
                                </div>
                                <div class="column is-half">
                                    <b-field label="Codigo" label-position="on-border">
                                        <b-input
                                        maxlength="10"
                                        v-model="c.code">
                                        </b-input>
                                    </b-field>
                                </div>

                                <div class="column is-one-third">
                                    <b-field label="% Descuento" label-position="on-border" message="Descuento porcentual. Dejar en 0 descuento fijo para que este aplique">
                                        <b-numberinput
                                        :controls="false"
                                        v-model="c.discountPercent">
                                        </b-numberinput>
                                    </b-field>
                                </div>
                                <div class="column is-one-third">
                                    <b-field label="$ Descuento" label-position="on-border" message="Descuento fijo. Dejar en 0 descuento porcentual para que este aplique">
                                        <b-numberinput
                                        :controls="false"
                                        v-model="c.discountFixed">
                                        </b-numberinput>
                                    </b-field>
                                </div>
                                <div class="column is-one-third">
                                    <b-field label="Valor minimo para usarlo" label-position="on-border" message="Monto minimo necesario de la orden para que este cupon se pueda usar">
                                        <b-numberinput
                                        :controls="false"
                                        v-model="c.minimumAmmount">
                                        </b-numberinput>
                                    </b-field>
                                </div>
                            </div>
                        </div>
                    </article>
                    
                    <div class="columns is-multiline">
                        <div class="column is-full">
                            <b-button @click="addLine" type="is-text">
                                Agregar linea
                                <b-icon icon="plus" size="is-small" class="m-l-5"></b-icon>
                            </b-button>
                        </div>
                        <div class="column is-full has-text-centered">
                            <b-button 
                            rounded
                            :loading="createLoading"
                            @click="createCoupons"
                            type="is-primary">
                                Crear
                                <b-icon icon="paper-plane" size="is-small" class="m-l-5"></b-icon>
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>    
</template>

<script>
import { getHandler, postHandler, patchHandler, debounce, deleteHandler } from '../../../../services/http'
export default {
    props:{
        couponsListCreate:{
            type:String,
            default:""
        },
        couponsDetail:{
            type:String,
            default:""
        },
        currencyEndpoint:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            loading:false,
            couponsList:[],
            addModalActive:false,
            createLoading:false,
            currencies:[],
            newCoupons:[
                {
                    title:'',
                    code:'',
                    discountPercent:0,
                    discountFixed:0,
                    minimumAmmount:0,
                    usersOnly:false
                }
            ]
        }
    },
    methods:{
        removeNewCoupon(i){
            this.newCoupons.splice(i, 1)
        },
        async fetchCoupons(){
            this.loading = true
            this.couponsList = await getHandler(this.couponsListCreate, {error:false, success:false})
            console.log(this.couponsList)
            this.loading = false
        },
        async fetchCurrencies(){
            this.loading = true
            this.currencies = await getHandler(this.currencyEndpoint, {error:false, success:false})
            this.loading = false
        },
        async createCoupons(){
            this.createLoading = true
            var error = {
                resource:"notify",
                text:"No se pudo crear ningun cupon, revisa loc campos y vuelve a intentarlo."
            }
            var success = {
                resource:"notify",
                text:"Cupon creado con exito"
            }
            var response = await postHandler(this.couponsListCreate, this.newCoupons, {error, success})
            this.addModalActive = false
            this.createLoading = false
            this.newCoupons = []
            this.fetchCoupons()
        },
        updateCoupon: debounce(
            async function(coupon){
                var error = {
                    resource:"toast",
                    text:"Algo salio mal, intentalo otra vez."
                }
                var success = {
                    resource:'toast',
                    text:'Cupon editado con exito.'
                }
                var url = this.couponsDetail.replace('0000', coupon.id)
                this.loading = true
                var response = await patchHandler(url, coupon, {error, success})
                this.loading = false
            },
            1000
        ),
        async deleteCoupon(id_){
            var error = {
                resource:"toast",
                text:"Algo salio mal, intentalo otra vez."
            }
            var success = {
                resource:'toast',
                text:'Cupon eliminado con exito.'
            }
            var url = this.couponsDetail.replace('0000', id_)
            var resp = await deleteHandler(url, {error, success})
            this.fetchCoupons()
        },
        addLine(){
            this.newCoupons.push({
                title:'',
                code:'',
                discountPercent:0,
                discountFixed:0,
                minimumAmmount:0,
                usersOnly:false
            })
        }
    },
    created(){
        this.fetchCoupons()
        this.fetchCurrencies()
    }
}
</script>

<style lang="scss" scoped>
.modal-card-body{
    border-radius:10px;
}
</style>